export default {"src":"/_next/static/media/phone_social.c5ff10a1.svg","height":1058,"width":794,"blurWidth":0,"blurHeight":0};